import script from "./MsgList.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgList.vue?vue&type=script&setup=true&lang=js"

import "./MsgList.vue?vue&type=style&index=0&id=1be32c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be32c64"]])

export default __exports__